<template>
    <div class="goods">
        <div class="scroll-nav-wrapper">
            <cube-scroll-nav
                    :side=true
                    :data="goods"
                    :options="scrollOptions"
                    v-if="goods.length"
            >
                <template slot="bar" slot-scope="props">
                    <cube-scroll-nav-bar
                            direction="vertical"
                            :labels="props.labels"
                            :txts="barTxts"
                            :current="props.current"
                    >
                        <template slot-scope="props">
                            <div class="text">
                                <support-ico
                                        v-if="props.txt.type>=1"
                                        :size=3
                                        :type="props.txt.type"
                                ></support-ico>
                                <span>{{props.txt.name}}</span>
                                <span class="num" v-if="props.txt.count">
                  <bubble :num="props.txt.count"></bubble>
                </span>
                            </div>
                        </template>
                    </cube-scroll-nav-bar>
                </template>
                <cube-scroll-nav-panel
                    style="background-color: white"
                        v-for="good in goods"
                        :key="good.name"
                        :label="good.name"
                        :title="good.name"
                >
                    <ul>
                        <li
                                @click="goGoodsDetail(food)"
                                v-for="food in good.foods"
                                :key="food.goods_id"
                                class="food-item"
                        >
                            <div class="icon">
                                <img width="57" height="57" :src="food.goods_image">
                            </div>
                            <div class="content">
                                <h2 class="name">{{food.goods_name}}</h2>
                                <p class="desc">{{food.goods_advword}}</p>

                                <div class="price">
                                    <span class="now">＄{{ utils.currencyPrice(food.goods_price) }}</span>
                                </div>
                                <div class="cart-control-wrapper">
                                    <cart-control :ref="'cart_control_'+food.goods_id" @add="onAdd" @showSpec="onShowSpec" @syncFood="syncFood" :parentFood="food"></cart-control>
                                </div>
                            </div>
                        </li>
                    </ul>
                </cube-scroll-nav-panel>
            </cube-scroll-nav>
        </div>
        <div class="shop-cart-wrapper">
            <shop-cart
                    ref="shopCart"
                    :select-foods="selectFoods"
                    :store_id="store.store_id"
                    :min-price="store.minPrice"></shop-cart>
        </div>
        <!-- <div><shopping :style="getBannerStyle" v-if="isShowcartInfo" :ifInStore="true" :isShowcartInfo="isShowcartInfo" @add="onGoodsAdd" :tempGoods="tempGoods"></shopping></div> -->
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { getStoreGoods } from '../../../api/homestoredetail'
import shopping from '../goodsdetail/child/Shopping'
import CartControl from './common/cart-control'
import ShopCart from './common/shop-cart'
import SupportIco from './common/support-ico/support-ico'
import Bubble from './common/bubble'
export default {
  name: 'StoredetailTabGoods',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      tempGoods:false,
      goods: [],
        index:[],
      scrollOptions: {
        click: false,
        directionLockThreshold: 0
      }
    }
  },
  created(){
    this.saveCartState(false)
  },
  computed: {
    ...mapState({
      // 是否显示购物车浮层
      isShowcartInfo: state => state.goodsdetail.isShowcartInfo
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      return {
        width: itemWidth + 'px',
        height:'100%',
        top:'1.4rem',
        left:'0',
        right:'0',
        bottom:'0',
        transform:'unset',
      }
    },
    store () {
      return this.data.store
    },
    selectFoods () {
      let foods = []
      this.goods.forEach((good) => {
        good.foods.forEach((food) => {
          if (food.count) {
            foods.push(food)
          }
        })
      })
      return foods
    },
    barTxts () {
      let ret = []
      this.goods.forEach((good) => {
        const { type, name, foods } = good
        let count = 0
        foods.forEach((food) => {
          count += food.count || 0
        })
        ret.push({
          type,
          name,
          count
        })
      })
      return ret
    }
  },
  methods: {
    ...mapActions({
		  getGoodsDetail: 'getGoodsDetail'
	  }),
    ...mapMutations({
      saveDetailInfo:'saveDetailInfo',
      saveCartState: 'saveCartState',
      saveNumber: 'saveNumber',
    }),
    onGoodsAdd(goods,mnumber){
      this.$refs['cart_control_'+this.tempGoods.goods_id][0].update(mnumber,goods.goods_id)
      this.saveCartState(false)
    },
    fetch () {
      if (!this.fetched) {
        this.fetched = true
        getStoreGoods(
          this.store.store_id,
          this.$route.query.keyword
        ).then((res) => {
          this.goods = res.result.storeclass_goods
          this.index = res.result.storeclass_index
          this.initShopCart(res.result.cart_list)
        }).catch(function (error) {
          Toast(error.message)
        })
      }
    },
    initShopCart(list) {
      this.$store.dispatch('resetShopCart')
      list.forEach(item => {
        this.$store.dispatch('addShopCart', item)
      })
    },
    onAdd (target) {
      this.$refs.shopCart.drop(target)
    },
    onShowSpec(goods){
      this.tempGoods=goods
      this.$emit('tempGoods', goods)
      this.saveDetailInfo(false)
      for(var i in goods.spec_list){
        if(goods.spec_list[i].goods_id==goods.goods_id){
          this.saveNumber(goods.spec_list[i].count?goods.spec_list[i].count:0)
          break
        }
      }

      this.getGoodsDetail({ goods_id: goods.goods_id, token: '' })
      .then(res => {
        this.saveCartState(true)
      })
      .catch(error => {
        Toast(error.message)
      })
    },
    syncFood(food){
      for(var i in this.index[food.goods_id]){
        this.goods[this.index[food.goods_id][i][0]]['foods'][this.index[food.goods_id][i][1]]=food
      }
      this.$forceUpdate()
    },
    // 跳转商品详情页
    goGoodsDetail (goods) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_common_id': goods.goods_commonid } })
    }
  },
  components: {
    Bubble,
    SupportIco,
    CartControl,
    ShopCart,
    // shopping
  }
}
</script>

<style lang="stylus" scoped>

    .goods
        position: relative
        text-align: left
        height: 100%
        .scroll-nav-wrapper
            position: absolute
            width: 100%
            top: 0
            left: 0
            bottom: 2.4rem
          >>> .cube-sticky
            background-color: #e6e6e5
        >>> .cube-scroll-nav-bar
            white-space: normal
            overflow: hidden
            text-align: right;
            display: flex;
            padding-left: 8px;
            justify-content: flex-end;
            background-color: #e6e6e5
        >>> .cube-scroll-nav-bar-item
            padding: 0 0.5rem
            display: flex
            align-items: center
            height: 2.8rem
            line-height: 0.7rem
            font-size: 0.6rem
            width: 3rem;
            background:#f3f5f7
            text-align: center
            .text
                flex: 1
                position: relative
            .num
                position: absolute
                right: -0.4rem
                top: -0.5rem
            .support-ico
                display: inline-block
                vertical-align: top
                margin-right: 0.2rem
        >>> .cube-scroll-nav-bar-item_active
            background: #fff
            color: #333
        >>> .cube-scroll-nav-panel-title
            padding-left: 0.7rem
            height: 1.3rem
            line-height: 1.3rem
            border-left: 0.1rem solid $color-col-line
            font-size: 0.6rem
            color: #666
            background:white
        .food-item
            display: flex
            margin: 0.9rem
            padding-bottom: 0.9rem
            position: relative
            &:last-child
                border-none()
                margin-bottom: 0
            .icon
                flex: 0 0 57px
                margin-right: 0.5rem
                img
                    height: auto
            .content
                flex: 1
                .name
                    margin: 0.1rem 0 0.4rem 0
                    height: 0.7rem
                    line-height: 0.7rem
                    font-size: 0.7rem
                    color: #333
                    font-weight: bolder
                .desc, .extra
                    line-height: 0.5rem
                    font-size: 0.5rem
                    color: #999
                .desc
                    line-height: 0.6rem
                    margin-bottom: 0.4rem
                .extra
                    .count
                        margin-right: 0.6rem
                .price
                    font-weight: 700
                    line-height: 1.2rem
                    .now
                        margin-right: 0.4rem
                        font-size: 0.7rem
                        color: #f01414
                    .old
                        text-decoration: line-through
                        font-size: 0.5rem
                        color: #999
            .cart-control-wrapper
                position: absolute
                right: 0
                bottom: 0.6rem
        .shop-cart-wrapper
            position: absolute
            left: 0
            bottom: 0
            z-index: 50
            width: 100%
            height: 2.4rem
</style>
